import Attachment from '@intercom/embercom-composer/blocks/types/attachment';
import { filterBy, mapBy } from '@ember/object/computed';
import Em from 'ember';
export default Em.ArrayProxy.extend({
  uploadedBlocks: filterBy('content', 'isUploadingOrHasUploadError', false),
  init() {
    this.set('content', Em.A());
    this._super(...arguments);
  },
  serialized: Em.computed('innerSerialized', 'length', 'uploadedBlocks.length', function () {
    if (this.get('uploadedBlocks.length') > 0) {
      return {
        type: 'attachmentList',
        attachments: this.get('innerSerialized')
      };
    }
    return null;
  }),
  innerSerialized: mapBy('uploadedBlocks', 'serialized'),
  fileUploadErrors: filterBy('content', 'hasUploadError'),
  deleteById(id) {
    let attachment = this._findById(id);
    this.removeObject(attachment);
  },
  retryById(id) {
    let attachment = this._findById(id);
    if (attachment) {
      attachment.retryUpload();
    }
  },
  _findById(id) {
    return this.get('content').findBy('id', id);
  }
}).reopenClass({
  deserialize(blocks, config, uploadManager) {
    let attachmentList = this.create({
      config
    });
    blocks = blocks || [];
    blocks.forEach(function (block) {
      if (block.type !== 'attachmentList') {
        return;
      }
      block.attachments = block.attachments || [];
      block.attachments.forEach(function (item) {
        item.config = config;
        item.uploadManager = uploadManager;
        attachmentList.pushObject(Attachment.create(item));
      });
    });
    return attachmentList;
  }
});